export default __webpack_public_path__ + "88c20623e401daacd3cbde91cf235227.png";